var _path, _path2, _path3, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 14,
    viewBox: "0 0 23 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.60659 2.52652C3.39071 0.963631 2.68955 0.0126953 1.83496 0.0126953C0.939328 0.0126953 0.302397 1.10636 0.0651091 2.52652C-0.359511 5.06889 1.43175 5.01002 1.43175 6.06086C1.43175 7.87353 1.43175 13.5881 1.43175 13.5881C1.43175 13.8146 1.61551 13.9984 1.84209 13.9984C2.06868 13.9984 2.25244 13.8146 2.25244 13.5881C2.25244 13.5881 2.25244 7.64338 2.25244 6.01269C2.25244 5.04035 3.92059 4.81198 3.60659 2.52652Z",
    fill: "#FFE5BF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.28315 0C7.10652 0 6.96201 0.144517 6.96201 0.321145V3.38626H6.40893V0.321145C6.40893 0.144517 6.26442 0 6.08779 0C5.90938 0 5.76665 0.144517 5.76665 0.321145V3.38626H5.21357V0.321145C5.21357 0.144517 5.06906 0 4.89243 0C4.7158 0 4.57129 0.144517 4.57129 0.321145V3.38626V3.88581V3.93042H4.57307C4.59091 4.36574 4.92276 4.64228 5.2778 4.86351C5.5704 5.04549 5.70956 5.34701 5.70956 5.7074C5.70956 7.61463 5.70956 13.5682 5.70956 13.5682C5.70956 13.8073 5.89332 14 6.11991 14C6.34649 14 6.53025 13.8073 6.53025 13.5682C6.53025 13.5682 6.53025 7.37199 6.53025 5.65566C6.53025 5.35058 6.61589 5.04549 6.87816 4.86887C7.23141 4.63158 7.58288 4.37288 7.60251 3.92864H7.60429V0.319359C7.60429 0.144515 7.46156 0 7.28315 0Z",
    fill: "#FFE5BF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2475 0.0178223C21.0325 0.0178223 20.8809 6.3122 20.8809 6.90453C20.8809 7.49864 21.2002 7.97857 21.5945 7.97857H22.1387C22.1387 10.0321 22.1387 13.5718 22.1387 13.5718C22.1387 13.8091 22.3224 14 22.5508 14C22.7774 14 22.9611 13.8073 22.9611 13.5718V1.09008C22.9611 0.497752 22.6418 0.0178223 22.2475 0.0178223Z",
    fill: "#FFE5BF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.0251,
    cy: 6.96038,
    r: 5.92156,
    fill: "#FFE5BF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.0abd64d9cf51b89f23af4085864ecf79.svg";
export { ForwardRef as ReactComponent };